<template>
    <div>
        <SToolbar>
            <v-icon small class="mr-1">ic-20 ic-service ic-col-grey</v-icon>
            <v-toolbar-title>{{ $t('service') }}</v-toolbar-title>
        </SToolbar>
        <v-card class="overflow-hidden">
            <BaseRemoteList
                class="service-list"
                session-key="service-list"
                :subtitle="$t('service_pages')"
                :collection-class="ServiceCollection"
                :headers="headers"
                :filters="filters"
                :extra-params="extraParams"
                :options="{ sortBy: ['title'], sortDesc: [false] }"
                :item-class="() => 'service-list-row'"
                cache-data
                height="var(--usable-height-with-double-toolbar)"
                @loading="loading = $event"
                @edit-item="onEdit"
                @new-item="onNew"
                @dblclick:row="onRowDblClick"
            >
                <template #toolbar-items>
                    |
                    <v-btn-toggle v-model="isPublishedFilter" class="ml-2" borderless tile background-color="primary">
                        <IconBtn
                            value="is_published"
                            color="primary"
                            :disabled="loading"
                            icon-cls="published"
                            icon-color="white"
                            icon-disabled-color="grey"
                            :tooltip="$t('publiziert')"
                        />
                        <IconBtn
                            value="is_not_published"
                            color="primary"
                            :disabled="loading"
                            icon-cls="rejected"
                            icon-color="white"
                            icon-disabled-color="grey"
                            :tooltip="$t('nicht_publiziert')"
                        />
                    </v-btn-toggle>
                </template>

                <template #[`item.title`]="{ item }">
                    <p class="page">{{ item.pageDisplay }}</p>
                    <h4>{{ item.title }}</h4>
                </template>
                <template #[`item.is_published`]="{ item }">
                    <KpIcon v-if="item.is_published" icon-cls="published" color="grey" :title="$t('publiziert')" />
                    <KpIcon v-else icon-cls="radio" color="grey" :title="$t('nicht_publiziert')" />
                </template>
                <template #[`item.link`]="{ item }">
                    <a :href="item.frontendUrl" target="_blank">{{ item.frontendUrl }}</a>
                </template>
                <template #[`item.genre_group_name`]="{ item }">
                    <div>
                        <strong>{{ item.genre_group_name }}</strong>
                        <span v-if="item.genre_name"> &gt; {{ item.genre_name }}</span>
                    </div>
                </template>
                <template #[`item.publish_from`]="{ item }">
                    <span class="pubdate_from"
                        >{{ item.$.publish_from.isValid() ? item.publish_from.formatIf('dd, DD.MM.YYYY') : '' }}
                    </span>
                    <span v-if="item.publish_to.isValid()" class="pubdate_to"
                        >{{ $t('bis') }} <br />
                        {{ item.$.publish_to.formatIf('dd, DD.MM.YYYY') }}
                    </span>
                </template>
                <template #[`item.modified`]="{ item }">
                    <span>{{ item.$.modified.isValid() ? item.modified.formatIf('dd, DD.MM.YYYY') : '' }}</span>
                </template>
            </BaseRemoteList>
        </v-card>
    </div>
</template>

<script>
import { ServiceCollection } from '@/models/Service';
import sessionStorageMixin from '@/mixins/session-storage';

export default {
    name: 'ServiceIndex',

    components: {},
    mixins: [sessionStorageMixin],

    data() {
        this.sessionKey = 'service-index';
        const data = {
            loading: false,
            ServiceCollection,
            headers: [
                { text: 'Aktionen', sortable: false, width: 80, value: 'actions' },
                { text: this.$t('status'), width: 100, sortable: true, value: 'is_published' },
                { text: this.$t('titel'), sortable: true, value: 'title' },
                { text: this.$t('link'), width: 120, sortable: false, value: 'link' },
                { text: this.$t('rubrik'), width: 120, sortable: true, value: 'genre_group_name' },
                { text: this.$t('pubdatum'), width: 180, sortable: true, value: 'publish_from' },
                { text: this.$t('modified'), width: 180, sortable: true, value: 'modified' },
                { text: '↓↑', width: 60, sortable: true, value: 'reihenfolge' },
            ],
            toggleFilters: this.getSessionValue('toggleFilters') || [],
            isPublishedFilter: this.getSessionValue('isPublishedFilter') || null,
        };

        return data;
    },
    computed: {
        filters() {
            const filters = [];
            if (this.isPublishedFilter === 'is_published') {
                filters.push({ property: 'is_published', value: true });
            }
            if (this.isPublishedFilter === 'is_not_published') {
                filters.push({ property: 'is_published', value: false });
            }
            return filters;
        },

        extraParams() {
            const toggleFilterList = ['btn_reg', 'btn_front', 'btn_mar'];
            const extraParams = {};
            toggleFilterList.forEach((ident) => {
                if (this.toggleFilters.indexOf(ident) >= 0) {
                    extraParams[ident] = true;
                }
            });

            return extraParams;
        },
    },

    watch: {
        toggleFilters(val) {
            this.setSessionValue('toggleFilters', [...val]);
        },
        isPublishedFilter(val) {
            if (val) {
                this.setSessionValue('isPublishedFilter', val);
            } else {
                this.clearSessionValue('isPublishedFilter');
            }
        },
    },
    methods: {
        onEdit(entry) {
            this.openEntry(entry);
        },

        onRowDblClick(e, data) {
            if (data.item) {
                this.openEntry(data.item);
            }
        },

        openEntry(entry) {
            this.$router.push({ name: 'service-edit', params: { id: entry.id } });
        },

        onNew() {
            this.$router.push({ name: 'service-edit', params: { id: 'new' } });
        },
    },
};
</script>

<style lang="scss" scoped>
.service-list {
    ::v-deep table > tbody > tr > td {
        vertical-align: top;
        color: var(--gray-text-color);
    }
}
.pubdate_from {
    color: var(--nearblack-color);
}
</style>
